<template>
  <div class="reports-add-jobs">
    <el-button
      style="width: 100%"
      size="small" class="add" :type="'primary'" @click="openDialog"
    >
      Выбрать работника
    </el-button>
    <el-dialog append-to-body title="Выбрать работника" :visible.sync="dialogObject" @close="close">
      <div style="display: flex; margin-bottom: 10px">
        <el-switch v-if="companyData && (role === 'admin' || companyData.enableSelectAll)"
                   v-model="isAllUser"></el-switch>
        <strong style="margin-left: 4px">Все работники</strong>
      </div>
      <div>
        <filter-select
          hideLabel
          style="margin-bottom: 5px"
          only-value
          noTag
          @addNew="addNew"
          :add-new-enable="!!company && !!companyData.enableCreateUser"
          v-model="form.employeeId"
          placeholder="Работник"
          :options="filterUsers"
        />
        <span v-if="tabelNumber" style="margin-bottom: 10px; display: flex">Табельный номер: {{ tabelNumber }}</span>
      </div>

      <filter-select
        style="margin-top: -20px;"
        v-if="$store.state.project.work_dir"
        placeholder="Раздел работ"
        v-model="form.dirId"
        label="Раздел работ"
        only-value
        :options="[{label: 'Без раздела работ', value: null}, ...workDirs]"
      />

      <filter-select
        style="margin-top: -20px"
        placeholder="Вид работы"
        v-model="form.workTypeId"
        label="Вид работы"
        only-value
        :options="workTypes"
      />

      <div style="display: flex">
        <el-input placeholder="Часы" v-model="form.hours" style="margin-right: 5px"></el-input>
        <el-input placeholder="Код" v-model="form.code" style="margin-left: 5px"></el-input>
      </div>

      <el-form-item label="Комментарий">
        <el-input type="textarea" v-model="form.comment"></el-input>
      </el-form-item>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="close">Отменить
        </el-button>
        <el-button
          @click="removeUser"
          v-if="editIndex !== null"
          style="margin-left: 4px; padding: 12px 8px"
          type="danger">Удалить
        </el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="save"
          type="primary">Сохранить
        </el-button>
      </div>
    </el-dialog>

    <el-dialog append-to-body title="Добавление нового сотрудника" :visible.sync="addNewUser">
      <users-create-company style="margin-top: -10px" @addNewUser="addNewUserEvent" :company="company"
                            ref="createCompany"/>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";
import FilterSelect from "../../../../components/FilterSelect";
import TabelProxy from "../../../../proxy/TabelProxy";
import UsersCreateCompany from "../../Users/company/UsersCreate";

export default {
  name: 'SelectUser',
  components: {UsersCreateCompany, FilterSelect},
  props: ['isWorkType', 'company', 'workTypes', 'workDirs', 'users', 'companyData', 'role'],
  data() {
    return {
      dialogObject: false,
      addNewUser: false,
      editIndex: null,
      isAllUser: false,
      optionsUsers: [],
      form: {
        employeeId: null,
        dirId: null,
        workTypeId: '',
        profId: "",
        code: "",
        hours: '',
        isSelect: false,
        comment: ""
      }
    };
  },
  computed: {
    getWorks() {
      if (!this.form.dirId) {
        return this.workTypes
      }

      return this.workTypes.filter(({dir}) => dir === this.form.dirId);
    },
    filterUsers() {
      const filterResult = (this.users || []).filter(({companyId}) => companyId === this.company)


      if (this.isAllUser) {
        return (this.users || [])
      }
      return [...filterResult, ...this.optionsUsers]
    },
    tabelNumber() {
      if (this.form.employeeId) {
        const user = this.users.find(({value}) => this.form.employeeId === value)
        if (!user) return ''
        return user.personnelNumber
      }
      return ''
    },
    profId() {
      if (this.form.employeeId) {
        const user = this.users.find(({value}) => this.form.employeeId === value)
        if (!user) return ''
        return user.profId
      }
      return ''
    },
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  methods: {
    selectWorkType(workTypeId) {
      if(this.$store.state.project.work_dir) {
        const work_type = this.workTypes.find(({value}) => value === workTypeId)
        const dir = this.prepareDirs(this.workDirs).find(({value}) => work_type.dir === value)
        console.log( this.workTypes, workTypeId, work_type, 'dir dir')
        if(dir) {
          this.form.dirId = dir.value
        }
      }
    },
    prepareDirs(dirs) {
      return dirs.map((r, key) => {
        return {
          ...r,
          label: r.label || r.name,
          value: r.value || r.id,
        }
      })
    },
    addNewUserEvent(id) {
      this.addNewUser = false;
      this.$emit('addNewUser')
      this.setUser(id)
    },
    addNew(name) {
      this.addNewUser = true;

      setTimeout(() => {
        this.$refs.createCompany.setName(name)
      }, 500)

    },
    setUser(employeeId) {
      this.form.employeeId = employeeId;
    },
    openDialog() {
      this.dialogObject = true;
    },
    openEdit(editIndex, form) {
      this.optionsUsers = []
      this.editIndex = editIndex
      this.form = JSON.parse(JSON.stringify(form))
      if (!this.form.workTypeId) {
        this.form.workTypeId = 'WITHOUT'
      }

      const user = this.filterUsers.find(({value}) => value === form.employeeId);

      if (!user) {
        this.optionsUsers = [{
          companyId: form.companyId,
          label: form.label,
          personnelNumber: '',
          profId: form.profId,
          value: form.employeeId
        }]
      }
      this.openDialog()
    },
    removeUser() {
      this.$emit('delete-user', this.editIndex)
      this.close()
    },
    save() {
      if (this.editIndex === null) {
        this.$emit('add-user', {
          ...this.form,
          profId: this.profId,
          workTypeId: (this.form.workTypeId === null || this.form.workTypeId === 'WITHOUT') ? "" : this.form.workTypeId
        });
      } else {
        this.$emit('update-user', {
          form: this.form,
          index: this.editIndex,
          workTypeId: (this.form.workTypeId === null || this.form.workTypeId === 'WITHOUT') ? "" : this.form.workTypeId
        });
      }
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.editIndex = null
      this.isAllUser = false
      this.optionsUsers = []
      this.form = JSON.parse(JSON.stringify({
        employeeId: null,
        dirId: null,
        workTypeId: '',
        profId: "",
        code: "",
        hours: '',
        isSelect: false,
        comment: ""
      }))
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/company/SelectUser.vue